import { createBrandTheme } from './createBrandTheme';
import arkose from './brands/arkose';

// Active brand for this deployment. To re-theme for a different climbing gym
// partner, add a token file under theme/brands/ and swap this import.
const activeBrand = arkose;

const theme = createBrandTheme(activeBrand);

export default theme;
